import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col } from "reactstrap";
import moment from "moment-timezone";

import classes from "./CampaignTruckModal.module.scss";
import Form from "../../../general/Form/Form";

const initialState = {
  truckCampaignName: "",
  startDate: "",
  endDate: "",
  startDateSelected: 1,
  endDateSelected: 1,
  loadedTruckCampaign: false
};

class CampaignTruckModal extends Component {
  state = initialState;

  onFormSubmitHandler = (e) => {
    e.preventDefault();
    let truckName = this.state.truckCampaignName;
    let startDate = this.state.startDateSelected === 2 ? moment(this.state.startDate).format("YYYY-MM-DD") : null;
    let endDate = this.state.endDateSelected === 2 ? moment(this.state.endDate).format("YYYY-MM-DD") : null;
    // clear fields
    this.setState(initialState);
    // send fields to campaign form
    this.props.edit ? this.props.update(truckName, startDate, endDate) : this.props.add(truckName, startDate, endDate);
  };

  deleteCampaignTruck = () => {
    // clear fields
    this.setState(initialState);
    // call delete to update ui
    this.props.delete();
  };

  startDateSelectHandler = (selected) => {
    this.setState({
      startDateSelected: selected
    });
  };

  endDateSelectHandler = (selected) => {
    this.setState({
      endDateSelected: selected
    });
  };

  truckCampaignNameChangeHandler = (e) => {
    this.setState({
      truckCampaignName: e.target.value
    });
  };

  startDateChangeHandler = (e) => {
    this.setState({
      startDate: e.target.value
    });
  };

  endDateChangeHandler = (e) => {
    this.setState({
      endDate: e.target.value
    });
  };

  toggle = () => {
    this.props.toggleModal();
    this.setState(initialState);
  };

  componentDidUpdate = () => {
    if (this.props.edit && !this.state.loadedTruckCampaign) {
      this.setState({
        loadedTruckCampaign: true,
        truckCampaignName: this.props.data.displayName,
        startDate: this.props.data.startDate === "Campaign Start" ? "" : moment(this.props.data.startDate).format("YYYY-MM-DD"),
        startDateSelected: this.props.data.startDate === "Campaign Start" ? 1 : 2,
        endDate: this.props.data.endDate === "Campaign End" ? "" : moment(this.props.data.endDate).format("YYYY-MM-DD"),
        endDateSelected: this.props.data.endDate === "Campaign End" ? 1 : 2
      });
    }
  };

  render() {
    const formStyle = {
      boxShadow: "none"
    };
    let deleteButton = this.props.edit ? (
      <Button
        color="danger"
        onClick={this.deleteCampaignTruck}
        style={{ position: "absolute", left: "25px", bottom: "calc(8px + 0.25em)" }}
      >
        Delete
      </Button>
    ) : null;
    return (
      <Modal isOpen={this.props.show} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>Truck Campaign Name & Timeline</ModalHeader>
        <ModalBody>
          <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
            <Row className="mb-2" form>
              <Col md={12}>
                <FormGroup>
                  <Label for="truckCampaignName">Display Name</Label>
                  <Input
                    type="text"
                    id="truckCampaignName"
                    placeholder="Truck name to show on campaign..."
                    value={this.state.truckCampaignName ? this.state.truckCampaignName : ""}
                    onChange={this.truckCampaignNameChangeHandler}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={6} className="pl-4 pr-4">
                <Label for="startDate">Tracking Start Date</Label>
                <Row className="mb-1">
                  <Button
                    color="success"
                    className={this.state.startDateSelected === 1 ? classes.active : classes.inactive}
                    onClick={() => this.startDateSelectHandler(1)}
                  >
                    First Available
                  </Button>
                </Row>
                <Row>
                  <Input
                    type="date"
                    className={this.state.startDateSelected === 2 ? classes.active : classes.inactive}
                    onClick={() => this.startDateSelectHandler(2)}
                    value={this.state.startDate}
                    onChange={this.startDateChangeHandler}
                  />
                </Row>
              </Col>
              <Col md={6} className="pl-4 pr-4">
                <Label for="endDate">Tracking End Date</Label>
                <Row className="mb-1">
                  <Button
                    color="warning"
                    className={this.state.endDateSelected === 1 ? classes.active : classes.inactive}
                    onClick={() => this.endDateSelectHandler(1)}
                  >
                    End of Campaign
                  </Button>
                </Row>
                <Row>
                  <Input
                    type="date"
                    className={this.state.endDateSelected === 2 ? classes.active : classes.inactive}
                    onClick={() => this.endDateSelectHandler(2)}
                    value={this.state.endDate}
                    onChange={this.endDateChangeHandler}
                  />
                </Row>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          {deleteButton}
          <Button color="primary" onClick={this.onFormSubmitHandler}>
            {this.props.edit ? "Edit" : "Add"}
          </Button>
          <Button color="secondary" onClick={this.toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CampaignTruckModal;
